module.exports = __webpack_public_path__ + "static/media/gov.debc568d.png";